import { STORE_RESTAURANTS_LIST } from "../actions";

export default function restaurantsList(state = {}, action) {
  switch (action.type) {
    case STORE_RESTAURANTS_LIST:
      return action.payload;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/restaurantsList.js